<script setup lang="ts">
  import type { ValidityHistoryItem } from '@/entities/Document';
  import { formatCivilDateToPtBR, formatInstantToPtBR, formatShortName } from '@/shared/lib';

  defineProps<{
    revision: ValidityHistoryItem;
  }>();

  const displayOrDash = (value: string | null | undefined): string =>
    value && value.trim() !== '' ? value : '-';

  const titleOrUndefined = (value: string | null | undefined): string | undefined =>
    value && value.trim() !== '' ? value : undefined;
</script>

<template>
  <tr class="hover:bg-gray-01 transition-colors duration-150">
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-07">
      {{ displayOrDash(revision.prefix) }}
    </td>
    <td class="px-6 py-4 text-sm text-gray-07">
      <div
        class="max-w-[220px] truncate"
        :title="titleOrUndefined(revision.documentName)"
      >
        {{ displayOrDash(revision.documentName) }}
      </div>
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-07">
      {{ revision.revision ?? '-' }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-07">
      <div v-if="revision.elaboration">
        <div
          class="max-w-[180px] truncate"
          :title="revision.elaboration.name"
        >
          Por: {{ formatShortName(revision.elaboration.name) }}
        </div>
        <div>Em: {{ formatInstantToPtBR(revision.elaboration.date) }}</div>
      </div>
      <div v-else>
        -
      </div>
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-07">
      <div v-if="revision.approval">
        <div
          class="max-w-[180px] truncate"
          :title="revision.approval.name"
        >
          Por: {{ formatShortName(revision.approval.name) }}
        </div>
        <div>Em: {{ formatInstantToPtBR(revision.approval.date) }}</div>
      </div>
      <div v-else>
        -
      </div>
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-07">
      <div v-if="revision.verification">
        <div
          class="max-w-[180px] truncate"
          :title="revision.verification.name"
        >
          Por: {{ formatShortName(revision.verification.name) }}
        </div>
        <div>Em: {{ formatInstantToPtBR(revision.verification.date) }}</div>
      </div>
      <div v-else>
        -
      </div>
    </td>
    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-07">
      {{ formatCivilDateToPtBR(revision.effectiveDate) }}
    </td>
  </tr>
</template>
